import { api } from '@/lib/api'
import type { Company, CreateCompanyPayload, UpdateCompanyPayload, DashboardData, InvestorSummary } from '@/types/company.types'

export const companyService = {
  async list(): Promise<Company[]> {
    const data = await api.get<{ companies: Company[] }>('/companies')
    return data.companies
  },

  async getById(id: string): Promise<Company> {
    const data = await api.get<{ company: Company }>(`/companies/${id}`)
    return data.company
  },

  async selectCompany(companyId: string): Promise<{ success: boolean; data: { companyId: string; status: string; message: string } }> {
    return api.post<{ success: boolean; data: { companyId: string; status: string; message: string } }>(`/companies/${companyId}/select`, {})
  },

  async create(payload: CreateCompanyPayload): Promise<Company> {
    const data = await api.post<{ company: Company }>('/companies', payload)
    return data.company
  },

  async update(id: string, payload: UpdateCompanyPayload): Promise<Company> {
    const data = await api.put<{ company: Company }>(`/companies/${id}`, payload)
    return data.company
  },

  async remove(id: string): Promise<void> {
    await api.delete(`/companies/${id}`)
  },

  async getDashboard(id: string): Promise<DashboardData> {
    const data = await api.get<{ dashboard: DashboardData }>(`/companies/${id}/dashboard`)
    return data.dashboard
  },

  async lookupCnpj(cnpj: string): Promise<any> {
    return api.get<any>(`/companies/cnpj/${cnpj}`)
  },

  async getInvestorSummary(): Promise<InvestorSummary> {
    return api.get<InvestorSummary>('/companies/investor/summary')
  },

  async updateInvestorParticipation(companyId: string, participationPercent: number): Promise<{ success: boolean; companyId: string; participationPercent: number; updatedAt: string }> {
    return api.put<{ success: boolean; companyId: string; participationPercent: number; updatedAt: string }>(
      `/companies/${companyId}/investor/participation`,
      { participationPercent }
    )
  },
}
